export const SET_SURVEY = "SET_SURVEY";
export const SET_USERRECORDID = "SET_USERRECORDID";
export const SET_SURVEY_ANSWER = "SET_SURVEY_ANSWER";
export const SET_NEXT_STEP = "SET_NEXT_STEP";
export const SET_PREVIOUS_STEP = "SET_PREVIOUS_STEP";
export const SET_IS_PREVIEW = "SET_IS_PREVIEW";
export const SET_SURVEY_ANSWER_FEEDBACK = "SET_SURVEY_ANSWER_FEEDBACK";

export const SET_PROFILE = "SET_PROFILE";
export const SET_PROFILE_AVATAR = "SET_PROFILE_AVATAR";
